import { useMutation } from '@apollo/client';
import { Dialog, DialogContent, DialogTitle } from '@mui/material';
import { gql } from '__generated__';
import { FC } from 'react';

import { FormInput, FormPanel } from 'components/FormPanel';

const UPDATE_DESIGNATION_MUTATION = gql(`
  mutation UpdateDesignation($id: ID!, $name: String!) {
    updateDesignation(id: $id, name: $name) {
      id
      name
      createdAt
      updatedAt
    }
  }
`);

const UpdateDesignationDialog: FC<{
  id: string;
  name: string;
  onClose: () => void;
}> = ({ id, name, onClose }) => {
  const [updateDesignation, { loading, error }] = useMutation(UPDATE_DESIGNATION_MUTATION, {
    onCompleted: onClose,
  });

  return (
    <>
      <Dialog open={true} onClose={onClose} maxWidth="xs" fullWidth>
        <DialogTitle>Update Designation</DialogTitle>
        <DialogContent sx={{ minHeight: '50vh' }}>
          <FormPanel
            loading={loading}
            error={error}
            onCancel={onClose}
            onSubmit={data => {
              updateDesignation({
                variables: {
                  id,
                  name: data.name,
                },
              });
            }}
          >
            <FormInput
              fullWidth
              type="string"
              fieldName="name"
              label="Name"
              defaultValue={name}
              validators={{
                required: true,
              }}
            />
          </FormPanel>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default UpdateDesignationDialog;
